import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { ViewportScroller } from '@angular/common';
import { ExceptionService } from '../../services/exception.service';

@Component({
  selector: 'app-pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.css']
})
export class PagerComponent implements OnInit {

  private _noScrollItemCountPerPage: number = 15;
  //private _previousPagingWasIncrementing: boolean = false;
  set noScrollItemCountPerPage(theValue: number) {
    this._noScrollItemCountPerPage = theValue;
    switch (this.itemCountPerPageSetting) {
      case PagerRowsPerPageEnum.NoScroll:
        this.itemCountPerPage = theValue;
        break;
    }
  }
  public itemCountPerPageSetting: PagerRowsPerPageEnum = PagerRowsPerPageEnum.NoScroll;

  public itemCountPerPageSettings = [
    { id: PagerRowsPerPageEnum.NoScroll, text: this.languageService.LNG("Label.NoScroll") },
    { id: PagerRowsPerPageEnum._20, text: '20' },
    { id: PagerRowsPerPageEnum._100, text: '100' },
    { id: PagerRowsPerPageEnum._500, text: '500' }];

  private _totalItemCount: number = 0;
  set totalItemCount(value: number) {
    this._totalItemCount = value;
    this.updatePager(null);
  }
  get totalItemCount(): number {
    return this._totalItemCount;
  }
  itemCountPerPage: number = 15;
  totalPageCount: number = 1;
  currentPage: number = 1;
  pagerAllPages: number[] = [];

  private windowStart: number;
  private windowStop: number;
  private windowMinPageNo: number;
  private windowMaxPageNo: number;
  @Input() windowSize: number = 4;
  @Input() navigateToTheTopOfThePageElementId: string = null;

  @Output() currentPageChanged = new EventEmitter<void>();

  constructor(public languageService: LanguageService, private viewPortScroller: ViewportScroller) {

  }

  ngOnInit(): void {
    this.currentPage = 1;
    this.windowStart = 1;
    this.windowStop = (this.windowSize + 1);
  }

  ngAfterViewInit() {
    this.setCurrentPage(1, false);
  }

  /**
   * If currentPageWasIncremented is null then no change to the paging-window
   * @param currentPageWasIncremented
   */
  private updatePager(currentPageWasIncremented?: boolean) {
    this.totalPageCount = Math.ceil(this.totalItemCount / this.itemCountPerPage);
    //Correct the current page if it goes out of valid scope
    if (this.currentPage > this.totalPageCount) {
      this.currentPage = Math.max(1, this.totalPageCount);
    }
    this.windowMinPageNo = (this.windowSize + 1);
    this.windowMaxPageNo = (this.totalPageCount - this.windowSize);
    const doWindowing = (this.totalPageCount > (this.windowMinPageNo * 2));
    if (doWindowing) {
      if (this.currentPage < this.windowMinPageNo) {
        //window is to the farmost left
        this.windowStart = 1;
        this.windowStop = (this.windowSize + 1);
      }
      else if (this.currentPage > this.windowMaxPageNo) {
        //window is to the farmost right
        this.windowStart = (this.totalPageCount - this.windowSize);
        this.windowStop = (this.totalPageCount);
      }
      else if (currentPageWasIncremented != null) {
        //window is on the move..
        if (currentPageWasIncremented) {
          if (this.currentPage == this.windowMinPageNo) {
            //...from the farmost left
            this.windowStart = (this.currentPage - 1);
            this.windowStop = (this.windowStart + this.windowSize - 1);
          }
          else if (this.currentPage == (this.windowMaxPageNo + 1)) {
            //...to the farmost right
            this.windowStart = (this.totalPageCount - this.windowSize);
            this.windowStop = (this.totalPageCount);
          }
          else if (this.currentPage == this.windowStop) {
            //...to the right
            this.windowStart += 1;
            this.windowStop += 1;
          }
        }
        else {
          if (this.currentPage == this.windowMaxPageNo) {
            //...from the farmost right
            this.windowStop = (this.windowMaxPageNo + 1);
            this.windowStart = (this.windowStop - this.windowSize + 1);
          }
          else if (this.currentPage == (this.windowMinPageNo - 1)) {
            //...to the farmost left
            this.windowStart = 1;
            this.windowStop = (this.windowSize + 1);
          }
          else if (this.currentPage == this.windowStart) {
            //...to the left
            this.windowStart -= 1;
            this.windowStop -= 1;
          }
        }
      }
    }

    var ps: number[] = [];
    if (doWindowing) {
      if (this.currentPage >= this.windowMinPageNo) {
        ps.push(1);
        ps.push(0);
      }
      for (var i = this.windowStart; i <= this.windowStop; i++) {
        ps.push(i);
      }
      if (this.windowStop <= (this.windowMaxPageNo + 1)) {
        ps.push(0);
        ps.push(this.totalPageCount);
      }
    }
    else {
      for (var i = 1; i <= this.totalPageCount; i++) {
        ps.push(i);
      }
    }
    this.pagerAllPages = ps;
  }

  itemCountPerSettingClicked(prppe: PagerRowsPerPageEnum) {
    this.itemCountPerPageSetting = prppe;
    switch (this.itemCountPerPageSetting) {
      case PagerRowsPerPageEnum.NoScroll:
        this.itemCountPerPage = this._noScrollItemCountPerPage;
        break;
      case PagerRowsPerPageEnum._20:
        this.itemCountPerPage = 20;
        break;
      case PagerRowsPerPageEnum._100:
        this.itemCountPerPage = 100;
        break;
      case PagerRowsPerPageEnum._500:
        this.itemCountPerPage = 500;
        break;
      default:
        alert("UNKNOWN PagerRowsPerPageEnum:" + this.itemCountPerPageSetting);
    }
    //stimulate a refresh of the data to adapt to the new page size
    var currentPage = this.currentPage;
    this.setCurrentPage(currentPage, true);
  }

  setCurrentPage(page: number, triggerCurrentPageChangedEvent = true) {
    let wasIncremented = null;
    if (page != this.currentPage) {
      wasIncremented = (page > this.currentPage);
    }
    this.currentPage = page;
    this.updatePager(!triggerCurrentPageChangedEvent ? null : wasIncremented);
    if (triggerCurrentPageChangedEvent) {
      this.currentPageChanged.emit();
    }
  }

  setCurrentPagePrevious() {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
      this.updatePager(false);
      this.currentPageChanged.emit();
    }
  }

  setCurrentPageNext() {
    if (this.currentPage < this.totalPageCount) {
      this.currentPage += 1;
      this.updatePager(true);
      this.currentPageChanged.emit();
    }
  }

  toTheTop() {
    if (this.navigateToTheTopOfThePageElementId != null) {
      this.viewPortScroller.scrollToAnchor(this.navigateToTheTopOfThePageElementId);
    }
  }
}

export enum PagerRowsPerPageEnum {
  NoScroll = 0,
  _20 = 1,
  _100 = 2,
  _500 = 3
}
